import React, { useEffect, useState } from 'react';
import { formattedCurrency, formattedNoMoneyCurrency } from '../../../utils/StringUtils';
import { TableBody, TableHead, TableRow, CircularProgress, Paper, Typography, Box, TableContainer, Table, Stack, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Tooltip, Divider } from '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow, ISTableCell, ISTableTitleSubtitle } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import PreorderDetail, { PreorderDetailInput } from '../../../models/PreorderDetail';
import PreorderProduct from '../../../models/PreorderProduct';
import PreorderDetailUpsert from './PreorderDetailUpsert';
import Discounts from '../../../models/Discount';
import Preorder, { PreorderInput } from '../../../models/Preorder';
import { useThemeContext } from '../../../theme/ThemeContext';
import { SessionState } from '../../../reducers/auth/session';
import { connect, useDispatch } from 'react-redux'
import { upsertPreorder } from '../../../actions/preorder/preorderUpsert'
import { deleteAllPreorderDetail, deletePreorderDetail } from '../../../actions/preorder/preorderDetailDelete'
import { fetchPreorder } from '../../../actions/preorder/preorder';
import CurrentPriceList from '../../../models/CurrentPriceList';
import { InfoOutlined, UploadFileOutlined, ShoppingCartCheckoutOutlined, RemoveShoppingCartOutlined, DeleteForeverOutlined, DeleteOutlineOutlined, FunctionsOutlined } from '@mui/icons-material';
import ProgressButton from '../../Utils/ProgressButton';
import { GenericModalDialog } from '../../modalDialog/GenericModalDialog';
import { ProductBrandListState } from '../../../reducers/product/productBrandList';
import { ProductSectionListState } from '../../../reducers/product/productSectionList';
import { ProductGroupListState } from '../../../reducers/product/productGroupList';
import { ProductSubgroupListState } from '../../../reducers/product/productSubgroupList';
import { Filters, FiltersBar, searchToFilters } from '../../Utils/Filters/Filter';
import { FilterBrand, FilterPreorderStuff } from '../../Utils/Filters';
import { PreorderDataState } from '../../../reducers/preorder/preorderData';
import { useHistory } from 'react-router-dom';
import { deletePreorder } from '../../../actions/preorder/preorderDelete';
import Prepayment from '../../../models/Prepayment';
import UsePrepayment from '../../../models/UsePrepayment';
import PreorderProductCodeForm from './PreorderProductCodeForm';
import { ProductRelations } from './PreordersList';
import { PERSON } from '../../../models/User';
import { roleToURLPrefix } from '../../../App';
import { fetchPreorderProducts } from '../../../actions/preorder/preorderProductList';
import { AppState } from '../../../reducers';
import { PreorderProductListState } from '../../../reducers/preorder/preorderProductList';
import { read, utils } from 'xlsx';
import { ProductListState } from '../../../reducers/product/productList';
import { updatePriceBulkPreorderDetail, upsertBulkPreorderDetail, upsertPreorderDetail } from '../../../actions/preorder/preorderDetailUpsert';
import { fetchPreorderAllProducts } from '../../../actions/preorder/preorderAllProductList';
import { PreorderAllProductListState } from '../../../reducers/preorder/preorderAllProductList';
import Product from '../../../models/Product';
import { Square } from '@mui/icons-material';
import { getToken } from '../../../utils/fetchApi';
import DeliveryLocation from '../../../models/DeliveryLocation';
import { ProvinceListState } from '../../../reducers/province/provinceList';
//import { LocalityListState } from '../../../reducers/locality/localityList';
import { fetchPreorderDetails } from '../../../actions/preorder/preorderDetail';
import { PreorderDetailListState } from '../../../reducers/preorder/preorderDetailList';

export interface Row {
  data: PreorderProduct
  action?: 'create' | 'update' | 'error';
}

export interface RowDetail {
  data: PreorderDetail
  action?: 'create' | 'update' | 'error';
}

interface Props {
  preorderProductList?: PreorderProductListState;
  preorderAllProductList?: PreorderAllProductListState;
  productList?: ProductListState;
  priceList?: CurrentPriceList;
  prepayment?: Prepayment;
  usePrepayment?: UsePrepayment[];
  prepaymentId?: string;
  surplusProduct?: () => PreorderProduct | undefined;
  surplusQty?: number;
  loading: boolean;
  loadingOthers: boolean;
  fromIn?: boolean;
  delivery: DeliveryLocation;
  session: SessionState;
  provinceList: ProvinceListState;
  //localityList: LocalityListState;
  productBrandsList: ProductBrandListState;
  productSectionsList: ProductSectionListState;
  productGroupsList: ProductGroupListState;
  productSubgroupsList: ProductSubgroupListState;
  preorderState: PreorderDataState;
  preorderDetail: PreorderDetailListState;
  productRelations: ProductRelations[];
  onChangePage?: (page: number) => void;
}

interface AuxiliarProps {
  initial: number
}


const emptyPreorder: Preorder = {
  id: null,
  dateCreated: '',
  clientId: 0,
  personId: 0,
  prepaymentId: '',
  priceListId: 0,
  dateUpdated: '',
  remarks: '',
  status: 'A'
}

interface BrandListCumulative {
  code: string
  brand: string
  total?: number
}

interface RemarksProps {
  onConfirm: (value1: string, value2: string) => void
  onCancel: () => void
  obs: string
  purchaseOrder: string
}

const RemarksDialog: React.FC<RemarksProps> = (props) => {
  const [obs, setObs] = useState<string>(props.obs)
  const [purchaseOrder, setPurchaseOrder] = useState<string>(props.purchaseOrder)
  const { t } = useTranslation(['preorder', 'menu'])

  const changeRemark = (newObs: string) => {
    setObs(newObs)
  }

  const changePurchaseOrder = (newPurchaseOrder: string) => {
    setPurchaseOrder(newPurchaseOrder)
  }

  return <GenericModalDialog isOpen={true}
    dialogProps={{ open: true, maxWidth: "lg" }}
    onConfirm={() => props.onConfirm && props.onConfirm(obs, purchaseOrder)}
    onCancel={() => props.onCancel && props.onCancel()} title={t('inProgress')}>
    <Stack textAlign="center">
      <Box style={{ justifyContent: 'center' }}>
        <TextField
          key="purchaseOrder"
          value={purchaseOrder}
          style={{
            width: "750px", margin: '10px 10px'
          }}
          variant="outlined"
          onChange={event => changePurchaseOrder(event.target.value)}
          inputProps={{ maxLength: 50 }}
          label={t('purchaseOrder')}
        />
      </Box>

      <Box style={{ justifyContent: 'center' }}>
        <TextField
          key="remarks"
          value={obs}
          style={{
            width: "750px", margin: '10px 10px'
          }}
          variant="outlined"
          multiline
          minRows={3}
          maxRows={3}
          onChange={event => changeRemark(event.target.value)}
          label={t('remarks')}
        />
      </Box>
    </Stack>
  </GenericModalDialog>
}

const sumDiscounts = (discounts: Discounts, originalValue: number) => {

  const calc = (value: number, percent: number) => percent ? value - (value * (percent / 100)) : value

  const toFixedDown = (data: number, digits: number) => {
    
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
      m = data.toString().match(re);
    return m ? parseFloat(m[1]) : data.valueOf();
  };

  /*
    var aux: number = originalValue
    if (discounts) {
      aux = calc(aux, discounts.bonificacion1)
      aux = calc(aux, discounts.bonificacion2)
      aux = calc(aux, discounts.bonificacion3)
      aux = calc(aux, discounts.bonificacion4)
      aux = calc(aux, discounts.bonificacion5)
      aux = calc(aux, discounts.bonificacion6)
      aux = calc(aux, discounts.bonificacion7)
      aux = calc(aux, discounts.bonificacion8)
      aux = calc(aux, discounts.bonificacion9)
      aux = calc(aux, discounts.bonificacion10)
    }
    // return Number.parseFloat(Number.parseFloat(aux.toString()).toFixed(4));
    return toFixedDown(aux, 4);
  */

  let aux: number = originalValue;

  if (discounts) {
    [discounts.bonificacion1, discounts.bonificacion2, discounts.bonificacion3, discounts.bonificacion4,
    discounts.bonificacion5, discounts.bonificacion6, discounts.bonificacion7, discounts.bonificacion8,
    discounts.bonificacion9, discounts.bonificacion10]
      .forEach(bonificacion => {
        aux = calc(aux, bonificacion);
      });
  }

  return toFixedDown(aux, 4);
};


interface XlsImportPreorderProps {
  isOpen: boolean
  preorderId: number
  products: ProductListState
  preorderAllProductList: PreorderAllProductListState
  priceListId: number
  money: string
  balance: number
  currentPreorderList: PreorderDetail[]
  onConfirm: (value: PreorderDetailInput[]) => void
  onCancel: () => void
}

const XlsImportPreorderDialog: React.FC<XlsImportPreorderProps> = (props) => {
  const { t } = useTranslation(['preorder', 'menu', 'others'])
  const [xlsPreorder, setXlsPreorder] = useState<any>([]);
  const [preordersToImport, setPreordersToImport] = useState<PreorderDetailInput[]>([]);
  const fileInput = React.useRef<HTMLInputElement>(null);
  const [isBulkingData, setIsBulkingData] = useState<boolean>(false)

  const handleXlsImportPreorder = async (file: File) => {
    const f = await file.arrayBuffer();
    const wb = read(f); // parse the array buffer
    const ws = wb.Sheets[wb.SheetNames[0]]; // get the first worksheet
    const data = utils.sheet_to_json(ws); // generate objects
    if (data.length > 500)
      data.splice(500);
    setXlsPreorder(data.map((d: any) => ({ ...d, description: '', amount: 0, error: 0, package: 0, adjust: 0 })))
  };

  const calcQty = (pack: number, qty: number) => {
    if (pack && qty)
      if ((qty % pack) === 0) {
        return qty
      }
    return qty + (pack - (qty % pack))
  }

  const totalToImport = (listToImport: PreorderDetailInput[]) => listToImport ?
    listToImport.reduce((amount, item) => amount + Number((item.price! * item.qty!)), 0) : 0

  useEffect(() => {
    const constructBulkPreorderDetail = () => {
      if (xlsPreorder) {
        let newPreordersToImport: PreorderDetailInput[] = []
        let allProducts: Product[] = []
        props.preorderAllProductList?.preorderAllProducts?.forEach(subgroup =>
          subgroup.products.forEach(product => allProducts.push(product)))

        xlsPreorder.forEach(xlsItem => {
          const resultProd = props.products.products?.find(p => p.status === 'A' && p.code === xlsItem[Object.keys(xlsItem)[0]].toString().padStart(7, '0'))
          if (resultProd) {
            const product = allProducts?.find(pr => pr.code === resultProd.code)
            const qty = calcQty(resultProd.package, xlsItem[Object.keys(xlsItem)[1]])
            const price = sumDiscounts(product?.discounts!, product?.price!)

            xlsItem.adjust = qty
            xlsItem.package = resultProd.package
            xlsItem.description = resultProd.description
            xlsItem.amount = qty * price


            if ((props.balance <= -1) ||
              ((props.balance >= 0) && (props.balance - totalToImport(newPreordersToImport)) > ((price * qty)))) {
              newPreordersToImport.push(
                {
                  id: null,
                  preorderId: props.preorderId || 0,
                  productId: resultProd.id || 0,
                  code: resultProd.code,
                  qty: qty,
                  package: resultProd.package,
                  priceListId: props.priceListId,
                  money: props.money,
                  listPrice: product?.price,
                  price: price,
                  discount1: Number(product?.discounts?.bonificacion1),
                  discount2: Number(product?.discounts?.bonificacion2),
                  discount3: Number(product?.discounts?.bonificacion3),
                  discount4: Number(product?.discounts?.bonificacion4),
                  discount5: Number(product?.discounts?.bonificacion5),
                  discount6: Number(product?.discounts?.bonificacion6),
                  discount7: Number(product?.discounts?.bonificacion7),
                  discount8: Number(product?.discounts?.bonificacion8),
                  discount9: Number(product?.discounts?.bonificacion9),
                  discount10: Number(product?.discounts?.bonificacion10),
                })
            }
            else {
              xlsItem.error = 2
              xlsItem.adjust = 0
              xlsItem.amount = 0.0
            }
          }
          else
            xlsItem.error = 1

        })
        setPreordersToImport(newPreordersToImport)
      }
    }
    constructBulkPreorderDetail()
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [xlsPreorder])

  const setAttachedFileInfo = async () => {
    const files = (fileInput as any).current.files as File[];
    if (files.length && files[0]) {
      handleXlsImportPreorder(files[0])
    }
  }


  const handleClose = (
    event: {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (reason !== "backdropClick") {
      setIsBulkingData(false);
      props.onCancel && props.onCancel();
    }
  };

  const { theme } = useThemeContext()

  const countItems = (type: number) =>
    xlsPreorder && xlsPreorder.length > 0 &&
    xlsPreorder.filter(element => type === 0 ? element.error === 0 && element[Object.keys(element)[1]] === element.adjust :
      type === 1 ? element.error === 1 :
        type === 2 ? element.error === 2 :
          type === 3 ? element.error === 0 && element[Object.keys(element)[1]] !== element.adjust : true).length

  return (
    <>
      <Dialog
        open={props.isOpen}
        maxWidth="lg"
        disableRestoreFocus
        onClose={handleClose}
      >
        <DialogTitle id="draggable-dialog" sx={{ cursor: 'auto', fontWeight: 'bold', height: '50px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {t('uploadSheet')}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: theme.palette.background.default }}>
          {!props.products.isFetching &&
            !props.preorderAllProductList.isFetching &&
            <Stack textAlign="center">
              <Box style={{ justifyContent: 'center' }}>
                <TextField
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ accept: "application/xlsx" }}
                  inputRef={fileInput}
                  label={t('loadFile')}
                  margin="normal"
                  size='small'
                  variant="outlined"
                  onChange={() => setAttachedFileInfo()}
                  type="file"
                  fullWidth
                  disabled={xlsPreorder && xlsPreorder.length > 0}
                />
              </Box>
              {xlsPreorder && xlsPreorder.length > 0 &&
                <Box style={{ justifyContent: 'center' }}>
                  <Table size="medium" stickyHeader={true}>
                    <TableHead >
                      <TableRow selected={true}>
                        <ISTableHeaderCell>{t('code')}</ISTableHeaderCell>
                        <ISTableHeaderCell >{t('description')}</ISTableHeaderCell>
                        <ISTableHeaderCell align='right'>{t('qty')}</ISTableHeaderCell>
                        <ISTableHeaderCell align='right'>{t('packageQty')}</ISTableHeaderCell>
                        <ISTableHeaderCell align='right'>{t('adjust')}</ISTableHeaderCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {xlsPreorder && xlsPreorder.map((row, index) => {
                        return <ISTableRow key={index} color='default'
                          sx={{
                            backgroundColor: row['error'] === 1 ? theme.palette.error.main :
                              row['error'] === 2 ? theme.palette.warning.main :
                                row[Object.keys(row)[1]] !== row['adjust'] ? theme.palette.info.dark : theme.palette.success.main, //'default',
                            lineHeight: "0.5rem", fontSize: "12px"
                          }}>
                          <ISTableCell sx={{ color: theme.palette.success.dark }}>

                            {row[Object.keys(row)[0]]!}
                          </ISTableCell>
                          <ISTableCell sx={{ color: theme.palette.success.dark }}>
                            {row['description'] ? row['description'] : row['error'] === 1 ? `-- ${t('inexistent')}-- ` : ''}
                          </ISTableCell>
                          <ISTableCell align='right' sx={{ color: theme.palette.success.dark }}>
                            {row[Object.keys(row)[1]]!}
                          </ISTableCell>
                          <ISTableCell align='right' sx={{ color: theme.palette.success.dark }}>
                            {row['package'] ? row['package'] : ''}
                          </ISTableCell>
                          <ISTableCell align='right' sx={{ color: theme.palette.success.dark }}>
                            {row['adjust'] ? row['adjust'] : '---'}
                          </ISTableCell>
                        </ISTableRow>
                      })}
                    </TableBody>
                  </Table>
                </Box>}
            </Stack>
          }
          {
            (props.products.isFetching ||
              props.preorderAllProductList.isFetching ||
              isBulkingData) &&
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress size={25} />
            </div>
          }
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between', backgroundColor: theme.palette.background.default }}>
          <Box>
            {!props.products.isFetching &&
              !props.preorderAllProductList.isFetching &&
              (!xlsPreorder || (xlsPreorder && !xlsPreorder.length)) &&
              <Button aria-label="download" color="secondary" variant="contained" size='small' style={{ textTransform: 'none' }}
                href={`${process.env.REACT_APP_API_URL}/preorder/template?access_token=${getToken()}`} target="_blank">
                &nbsp;{`${t('download', { ns: 'others' })} ${t('template')}`}&nbsp;
              </Button>}
          </Box>
          {xlsPreorder && xlsPreorder.length > 0 &&
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} variant='caption' color={theme.palette.success.main}>
                  {t('result')}&nbsp;
                </Typography>
                <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} variant='caption' color={theme.palette.success.main}>
                  &nbsp;
                </Typography>
                <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} variant='caption' color={theme.palette.success.main}>
                  {t('infoImportText.title')}&nbsp;
                  <Square style={{ fontSize: 'small', color: theme.palette.success.main }} />
                </Typography>
                <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} variant='caption' color={theme.palette.info.dark}>
                  {t('warningImportText.title')}&nbsp;
                  <Square style={{ fontSize: 'small', color: theme.palette.info.dark }} />
                </Typography>
                {props.balance > 0 &&
                  <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} variant='caption' color={theme.palette.warning.main}>
                    {t('infoImportText.title')}&nbsp;
                    <Square style={{ fontSize: 'small', color: theme.palette.warning.main }} />
                  </Typography>}
                <Typography sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} variant='caption' color={theme.palette.error.main}>
                  {t('errorImportText.title')}&nbsp;
                  <Square style={{ fontSize: 'small', color: theme.palette.error.main }} />
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant='caption' color={theme.palette.success.main}>&nbsp;&nbsp;{'-'}&nbsp;&nbsp;</Typography>
                <Typography variant='caption' color={theme.palette.success.main}>&nbsp;</Typography>
                <Typography variant='caption' color={theme.palette.success.main}>&nbsp;&nbsp;{'-'}&nbsp;&nbsp;</Typography>
                <Typography variant='caption' color={theme.palette.info.dark}>&nbsp;&nbsp;{'-'}&nbsp;&nbsp;</Typography>
                {props.balance > 0 && <Typography variant='caption' color={theme.palette.warning.main}>&nbsp;&nbsp;{'-'}&nbsp;&nbsp;</Typography>}
                <Typography variant='caption' color={theme.palette.error.main}>&nbsp;&nbsp;{'-'}&nbsp;&nbsp;</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                  <Typography variant='caption' color={theme.palette.success.main}>
                    {t('accepted')}:&nbsp;{(Number(countItems(0)) + Number(countItems(3))).toString()}&nbsp;&nbsp;{'('}{countItems(0).toString()}&nbsp;+&nbsp;
                  </Typography>
                  <Typography variant='caption' color={theme.palette.info.dark}>
                    {countItems(3).toString()}
                  </Typography>
                  <Typography variant='caption' color={theme.palette.success.main}>
                    {')'}&nbsp;&nbsp;-&nbsp;&nbsp;
                  </Typography>
                  <Typography variant='caption' color={theme.palette.info.dark}>
                    {t('warningImportText.type')}:&nbsp;{countItems(3).toString()}&nbsp;&nbsp;-&nbsp;&nbsp;
                  </Typography>
                  {props.balance > 0 && <Typography variant='caption' color={theme.palette.warning.main}>
                    {t('infoImportText.type')}:&nbsp;{countItems(2).toString()}&nbsp;&nbsp;-&nbsp;&nbsp;
                  </Typography>}
                  <Typography variant='caption' color={theme.palette.error.main}>
                    {t('errorImportText.type')}:&nbsp;{countItems(1).toString()}
                  </Typography>
                </Box>
                <Typography variant='caption' color={theme.palette.success.main}>&nbsp;</Typography>
                <Typography variant='caption' color={theme.palette.success.main}>{t('accepted')}</Typography>
                <Typography variant='caption' color={theme.palette.info.dark}>{t('warningImportText.description')}</Typography>
                {props.balance > 0 && <Typography variant='caption' color={theme.palette.warning.main}>{t('infoImportText.description')}</Typography>}
                <Typography variant='caption' color={theme.palette.error.main}>{t('errorImportText.description')}</Typography>
              </Box>
            </Box>}
          <Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
            {props.onCancel && <Button style={{ marginRight: '8px', textTransform: 'none' }} color="error" variant="contained" onClick={() => props.onCancel && props.onCancel()}>{t('cancel')}</Button>}
            {props.onConfirm && <Button disabled={xlsPreorder.length === 0} style={{ marginRight: '8px', textTransform: 'none' }} color="success" variant="contained"
              data-testid="generic-ok" onClick={() => { setIsBulkingData(true); props.onConfirm && props.onConfirm(preordersToImport) }}>{t('upload')}</Button>}
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );

}


const PreorderProducts: React.FC<Props> = (props) => {
  const { t } = useTranslation(['preorder', 'menu', 'delivery'])
  const { theme, darkModeEnabled } = useThemeContext()
  const dispatch = useDispatch()
  const history = useHistory()

  const [preorderId, setPreorderId] = useState<number | null>(props.preorderState.preorder?.id || null)
  const [addingPreorder, setAddingPreorder] = useState<boolean>(false)
  const [showDeleteAllDialog, setShowDeleteAllDialog] = useState<boolean>(false)
  const [showDiscardDialog, setShowDiscardDialog] = useState<boolean>(false)
  const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false)
  const [showRemarksDialog, setShowRemarksDialog] = useState<boolean>(false)
  const [showInfoPreorderDialog, setShowInfoPreorderDialog] = useState<boolean>(false)
  const [showChangePricesDialog, setShowChangePricesDialog] = useState<boolean>(false)
  const [showBrandCumulativeDialog, setShowBrandCumulativeDialog] = useState<boolean>(false)
  const [showXlsImportPreorderDialog, setShowXlsImportPreorderDialog] = useState<boolean>(false)
  const [deletingDetails, setDeletingDetails] = useState<boolean>(false)
  const [revaluing, setRevaluing] = useState<boolean>(false)
  const [preorderInfo, setPreorderInfo] = useState<Preorder>(props.preorderState.preorder || emptyPreorder)
  const [preorderUrgent, setPreorderUrgent] = useState<boolean>(props.preorderState.preorder?.urgent || false)
  const [brandListData, setBrandListData] = useState<BrandListCumulative[] | undefined>(undefined)
  const [rowsToShow, setRowsToShow] = useState<Row[] | undefined>([])
  const [selectedBrand, setSelectedBrand] = useState<number>(0)
  const [selectedSection, setSelectedSection] = useState<number>(0)
  const [selectedGroup, setSelectedGroup] = useState<number>(0)
  const [darkModeChange, setDarkModeChange] = useState<boolean>(false)


  const initPreordersFilters: Filters = {
    brand: '',
    section: '',
    group: '',
    subgroup: ''
  }

  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }

  const maxProducts = () => {
    let maxValue = 0
    if (rowsToShow)
      rowsToShow.forEach(row => { maxValue = Math.max(maxValue, row.data.products.length) })
    return maxValue
  };

  const handlePreorder = (preorder: Preorder) => {
    if( preorder.id )
    {
      setPreorderId(preorder.id)
      setPreorderInfo(preorder)
      dispatch(fetchPreorder(preorder.id))
      dispatch(fetchPreorderDetails(preorder.id.toString()!, undefined, '?limit=1000'))
    }
    else addPreorder()
  }

  const addPreorder = () => {
    const initialPreorder: PreorderInput = {
      id: null,
      clientId: 0, // ver en el futuro cuando es un vendedor
      prepaymentId: props.prepayment?.id_acopio || '',
      priceListId: props.priceList?.codigo_listadeprecios || 0,
      orderId: '',
      status: 'A',
      money: props.priceList?.moneda || '$',
      remarks: '',
      warehouse: props.session.isChaco ? 3 : undefined,
      dl_address: props.delivery.domicilio,
      dl_locality: props.delivery.localidad,
      dl_zipCode: props.delivery.codigopostal,
      dl_provinceCode: props.delivery.codigo_provincia,
      dl_phone: props.delivery.telefono,
      dl_openingHours: props.delivery.horariodeatencion,
      dl_localityCode: props.delivery.codigo_localidad,
      dl_deliveryArea: props.delivery.codigo_zonadereparto,
      dl_main: props.delivery.principal,
      deliveryAddressId: props.delivery.orden,
      internalRemarks: props.delivery.quienrecibe ? `Recibe ${props.delivery.quienrecibe} - ${props.delivery.telefono}` : undefined
    }
    setAddingPreorder(true)
    dispatch(upsertPreorder(initialPreorder, handlePreorder))
  }

  const hasPriceListChanged = () => {
    if (props.priceList && !props.prepaymentId &&
      props.preorderState && !props.preorderState.isFetching && props.preorderState.preorder &&
      props.preorderState.preorder.detail && props.preorderState.preorder.detail.length > 0 &&
      !props.preorderState.preorder.prepaymentId) {
      return setShowChangePricesDialog(props.priceList.codigo_listadeprecios !== props.preorderState.preorder.detail[0].priceListId)
    }
    return setShowChangePricesDialog(false)
  }

  const handleRevalue = async () => {
    setRevaluing(true)
    setShowChangePricesDialog(false)
    if (props.preorderState.preorder && props.preorderState.preorder.detail && props.preorderState.preorder.detail.length > 0)
      await dispatch(updatePriceBulkPreorderDetail(props.preorderState.preorder.detail))

    await dispatch(upsertPreorder({ ...preorderInfo, priceListId: props.priceList?.codigo_listadeprecios! }))
    dispatch({ type: 'PREORDER_CLEAR' })
    dispatch({ type: 'PREORDER_DETAIL_CLEAR' })
    dispatch({ type: 'PREORDER_PRODUCT_LIST_CLEAR' })
    dispatch({ type: 'PREPAYMENT_CLEAR' })
    dispatch({ type: 'INFO_CURRENT_PRICE_LIST_CLEAR' })
    setRevaluing(false)

    //const detailUrl = `/${props.session.roles && roleToURLPrefix(props.session.roles.filter(role => role !== PERSON)[0])}/dashboard`
    const detailUrl = `/${props.session.roles && roleToURLPrefix(props.session.roles.filter(role => role !== PERSON)[0])}/preorders/main`
    history.push(detailUrl)
  }

  const revalueAll = async () => await handleRevalue()

  useEffect(() => {
    setDarkModeChange(darkModeEnabled)
  }, [darkModeEnabled])

  useEffect(() => {
    const search = `${props.prepaymentId ? props.prepaymentId : ''}${history.location.search ? `${history.location.search}&` : '?'}limit=25`
    if (props.prepaymentId !== undefined)
      dispatch(fetchPreorderProducts(search));
  }, [dispatch, history.location.search, props.prepaymentId])

  useEffect(() => {
    const filters = searchToFilters(history.location.search)
    setSelectedBrand(filters.brand ? parseInt(filters.brand) : 0)
    setSelectedSection(filters.section ? parseInt(filters.section) : 0)
    setSelectedGroup(filters.group ? parseInt(filters.group) : 0)
    //setSelectedSubgroup(filters.subgroup ? parseInt(filters.subgroup) : 0)
  }, [history.location.search])



  useEffect(() => {
    if (props.preorderProductList && !props.preorderProductList.isFetching && props.preorderProductList.preorderProducts && !props.loading) {
      setRowsToShow((props.preorderProductList.preorderProducts).map((s: any) => ({ data: s })))
    }
  }, [props.preorderProductList, props.preorderProductList?.isFetching, props.loading])

  useEffect(() => {
    if (!props.loadingOthers && !props.loading && !props.preorderState.preorder && props.delivery &&
      (!props.prepaymentId || (props.prepaymentId && props.prepayment)) && !preorderId && props.priceList && !addingPreorder) {
      addPreorder()
    }
    if (!props.loadingOthers && !props.loading && props.preorderState.preorder &&
      props.preorderProductList && !props.preorderProductList?.isFetching &&
      !props.prepaymentId && preorderId && props.priceList) {
      hasPriceListChanged()
    }
    // eslint-disable-next-line     
  }, [props.loadingOthers, props.loading, props.prepaymentId, props.prepayment, props.priceList,
  props.preorderProductList, props.preorderProductList?.isFetching,
  props.preorderState.preorder, preorderId, addingPreorder])

  useEffect(() => {
    if (props.preorderState.preorder && preorderId !== props.preorderState.preorder.id && props.preorderState.preorder.id !== null &&
      props.preorderState.preorder.id !== 0) {
      setPreorderId(props.preorderState.preorder.id) // || preorderId)
      setPreorderInfo(props.preorderState.preorder)
    }
    if (props.preorderState.preorder && props.preorderState.preorder.urgent !== preorderUrgent) {
      setPreorderUrgent(props.preorderState.preorder.urgent!)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.preorderState.preorder])

  const filterRelations = () => props.productRelations.filter(r => (selectedBrand ? r.brandId === selectedBrand : true) &&
    (selectedSection ? r.sectionId === selectedSection : true) &&
    (selectedGroup ? r.groupId === selectedGroup : true)
    /* &&
(selectedSubgroup ? r.subgroupId === selectedSubgroup : true)*/)

  const brandList = () => props.productBrandsList.productBrands //?.filter(b => filterRelations().some(r => b.id === r?.brandId))
  //const sectionList = () => props.productSectionsList.productSections?.filter(s => filterRelations().some(r => s.id === r?.sectionId))

  //hacer que la seccion siempre tenga todas las opciones y solo condicione los grupos y subgrupos asi ? 
  const sectionList = () => props.productSectionsList.productSections // ?.filter(s => filterRelations().some(r => s.id === r?.sectionId))

  const groupList = () => props.productGroupsList.productGroups?.filter(g => filterRelations().some(r => g.id === r?.groupId))

  //const subgroupList = () => props.productSubgroupsList.productSubgroups?.filter(sg => filterRelations().some(r => sg.id === r?.subgroupId))

  const subgroupList = () => {
    // Filtrar las relaciones según los filtros
    const filteredRelations = props.productRelations.filter(
      r =>
        (selectedBrand ? r.brandId === selectedBrand : true) &&
        (selectedSection ? r.sectionId === selectedSection : true) &&
        (selectedGroup ? r.groupId === selectedGroup : true)
    );

    // Filtrar los subgrupos basados en las relaciones filtradas
    const subgroups = props.productSubgroupsList.productSubgroups?.filter(sg =>
      filteredRelations.some(r => r.subgroupId === sg.id)
    ) || [];

    return subgroups;
  };

  const getPreorder = () => preorderId!

  const setPreorder = async () => {
    await dispatch(fetchPreorder(preorderId))
  }

  const onClickDelete = async (preorderDetailId: number) => {
    await dispatch(deletePreorderDetail(preorderDetailId))
    await dispatch(fetchPreorder(preorderId, () => dispatch(fetchPreorderDetails(preorderId?.toString()!, undefined, '?limit=1000'))))

  }

  const handleDeleteAll = () => {
    if (props.preorderState.preorder && props.preorderState.preorder.detail && props.preorderState.preorder.detail.length > 0)
      setShowDeleteAllDialog(true)
  }

  const handleDiscard = () => {
    if (props.preorderState.preorder)
      setShowDiscardDialog(true)
  }

  const handleRemarks = () => {
    if (props.preorderState.preorder && props.preorderState.preorder.detail && props.preorderState.preorder.detail.length > 0)
      setShowRemarksDialog(true)
  }


  const deleteAll = async () => await handleDelete(preorderId!, false)

  const discard = async () => await handleDelete(preorderId!, true)

  const remarks = async () => handleRemarksPreorder()

  const confirmPreorder = async () => await handleConfirmPreorder()

  const handleDelete = async (preorderId: number, andDiscard: boolean) => {
    setDeletingDetails(true)
    if (andDiscard)
      setShowDiscardDialog(false)
    if (props.preorderState.preorder && props.preorderState.preorder.detail && props.preorderState.preorder.detail.length > 0)
      await dispatch(deleteAllPreorderDetail(preorderId))

    if (andDiscard) {
      await dispatch(deletePreorder(preorderId))
      dispatch({ type: 'PREORDER_CLEAR' })
      dispatch({ type: 'PREORDER_DETAIL_CLEAR' })
      dispatch({ type: 'PREORDER_PRODUCT_LIST_CLEAR' })
      dispatch({ type: 'PREPAYMENT_CLEAR' })
      dispatch({ type: 'INFO_CURRENT_PRICE_LIST_CLEAR' })

      setPreorderInfo(emptyPreorder)
      const detailUrl = `/${props.session.roles && roleToURLPrefix(props.session.roles.filter(role => role !== PERSON)[0])}/dashboard`
      history.push(detailUrl)
    }
    else {
      setShowDeleteAllDialog(false)
      await dispatch(fetchPreorder(preorderId, () => dispatch(fetchPreorderDetails(preorderId?.toString()!, undefined, '?limit=1000'))))
    }
    setDeletingDetails(false)
  }

  const handleRemarksPreorder = async () => {
    setShowRemarksDialog(false)
    setShowConfirmDialog(true)
  }

  const handleConfirmPreorder = async () => {
    setShowConfirmDialog(false)
    await dispatch(upsertPreorder({ ...preorderInfo,  priceListId: props.priceList && props.priceList.codigo_listadeprecios !== preorderInfo.priceListId ? props.priceList.codigo_listadeprecios : preorderInfo.priceListId, status: 'P' }))
    dispatch({ type: 'PREORDER_CLEAR' })
    dispatch({ type: 'PREORDER_DETAIL_CLEAR' })
    dispatch({ type: 'PREORDER_PRODUCT_LIST_CLEAR' })
    dispatch({ type: 'PREPAYMENT_CLEAR' })
    dispatch({ type: 'INFO_CURRENT_PRICE_LIST_CLEAR' })

    setPreorderInfo(emptyPreorder)
    const detailUrl = `/${props.session.roles && roleToURLPrefix(props.session.roles.filter(role => role !== PERSON)[0])}/dashboard`
    history.push(detailUrl)
  }

  const handleXlsPreviuosImport = async () => {
    dispatch(fetchPreorderAllProducts(props.prepaymentId ? `${props.prepaymentId}` : ''))
    dispatch(fetchPreorder(preorderId))
    setShowXlsImportPreorderDialog(true)
  }


  const handleBulkPreorderImport = async (preorderDetailList: PreorderDetailInput[]) => {
    let updatableList: PreorderDetail[] = []

    const handleResponse = () => {
      setPreorder()
      if (updatableList.length > 0) {
        updatableList.forEach((a, i) => dispatch(upsertPreorderDetail(a, (i === updatableList.length - 1) ? () => {
          dispatch(fetchPreorderDetails(preorderId?.toString()!, undefined, '?limit=1000'))
          setPreorder()
        } : undefined)))
      }
      else {
        setPreorder()
        dispatch(fetchPreorderDetails(preorderId?.toString()!, undefined, '?limit=1000'))
      }
      setShowXlsImportPreorderDialog(false)
    }

    let notDuplicateInList: PreorderDetailInput[] = []

    if (preorderDetailList && preorderDetailList.length > 0) {
      preorderDetailList.forEach(a => {
        const qty = a?.qty ?? 0
        const found = notDuplicateInList.find(b => a.code === b.code)
        if (found) {
          found.qty = Number(found.qty) + Number(qty)
        }
        else {
          notDuplicateInList.push(a)
        }
      })
    }

    let notInList = notDuplicateInList.filter(a => a.qty !== 0)

    if (props.preorderState.preorder && props.preorderState.preorder.detail) {
      const inList = notInList.filter(a => props.preorderState.preorder?.detail?.some(b => a.code === b.code));
      notInList = notInList.filter(a => props.preorderState.preorder?.detail?.every(b => a.code !== b.code));

      if (inList && inList.length > 0 && props.preorderState.preorder && props.preorderState.preorder.detail) {
        inList.forEach(a => {
          if (props.preorderState.preorder && props.preorderState.preorder.detail &&
            props.preorderState.preorder.detail.find(b => a.code === b.code) && a) {
            const qty = a?.qty ?? 0
            const found = props.preorderState.preorder.detail.find(b => a.code === b.code)
            if (found)
              updatableList.push({ ...found, qty: Number(found.qty) + Number(qty) })
          }
        })
      }
    }

    if (props.preorderState && props.preorderState.preorder && props.preorderState.preorder.detail && props.preorderState.preorder.detail.length > 0)
      if ((notInList.length + props.preorderState.preorder.detail.length) > 500)
        notInList.splice(500 - props.preorderState.preorder.detail.length)

    if (notInList) {
      dispatch(upsertBulkPreorderDetail(notInList, () => {
        handleResponse()
      }))
    }
    else handleResponse()
  }

  const CompleteHeaderCells: React.FC<AuxiliarProps> = ({ initial }) => {
    return (
      <>
        {Array.from({ length: maxProducts() - initial }, (_, index) => (
          <ISTableHeaderCell key={index} padding="none" align="center" sx={{ minWidth: '180px', width: '180px', lineHeight: "0.5rem", fontSize: "12px" }} />
        ))
        }
      </>)
  }

  const CompleteDataCells: React.FC<AuxiliarProps> = ({ initial }) => {
    return (
      <>
        {Array.from({ length: maxProducts() - initial }, (_, index) => (
          <ISTableCell key={index} padding="none" align="center" />
        ))
        }
      </>)
  }
  /*  
  ver con los datos que ya tenemos los totales de los comprobantes, analizar los netos para controlar el total del carrito por acopio
  */
  const cumulative = () => {
    return props.preorderState.preorder && props.preorderState.preorder.detail ?
      props.preorderState.preorder.detail.reduce((amount, det) => amount + Number(det.amount), 0) : 0
  }

  const tooltipText = (text: string) =>
    <Paper elevation={2} sx={{ padding: "10px" }}>
      <Typography >{text}</Typography>
    </Paper>

  const notShowingDialogs = () => !showDeleteAllDialog && !showDiscardDialog && !showConfirmDialog && !showRemarksDialog && !showInfoPreorderDialog

  const getSurplusProduct = () => {
    const surplusProduct = props.surplusProduct && props.surplusProduct()
    return surplusProduct && surplusProduct.products && surplusProduct.products.length > 0  ?
     sumDiscounts(surplusProduct.products[0].discounts!, surplusProduct.products[0].price) * props.surplusQty! : 0
  } 

  const balancePrepayment = (withSurplus: Boolean) => {
    if (props.prepayment) {
      return props.prepayment.saldoNeto !== undefined ? props.prepayment.saldoNeto + (withSurplus ? getSurplusProduct() : 0) : 0
    }
    return -1
  }

  const balanceTotalPrepayment = () => {
    if (props.usePrepayment) {
      if (props.usePrepayment.length > 0)
        return props.usePrepayment.reduce((neto, mov) =>
          neto + Number(mov.codigo_comprobante_utilizacion ? mov.importe_comprobante_utilizacion : mov.importe), 0)
    }
    if (props.prepayment)
      return props.prepayment.importe
    return -1
  }

  const brandListCumulative = () => {
    const brands = props.productBrandsList.productBrands;

    if (props.preorderState.preorder &&
      props.preorderState.preorder.detail &&
      props.preorderState.preorder.detail.length > 0) {
      const brand = brands?.map(b => ({ code: b.code, brand: b.description, total: props?.preorderState?.preorder?.detail?.filter(d => d.product?.brandId === b.id).reduce((amount, det) => amount + Number(det.amount), 0) }))
      if (brand) {
        setBrandListData(brand)
        setShowBrandCumulativeDialog(true)
      }
    }
  }

  const PrepaymentInfo = ({ prepayment }) => {
    if (!prepayment)
      return <Typography variant="subtitle1" sx={{ padding: "10px", color: theme.palette.success.dark }}>{t('cumulative')} {formattedCurrency(cumulative())}</Typography>
    return (
      <>
        {/*<Typography variant="subtitle1" sx={{ padding: "10px", color: theme.palette.success.dark }}>{t('prepaymentId')} {prepayment.numero} / {Number(prepayment.id_factura.slice(8))}</Typography>*/}
        <Typography variant="subtitle1" sx={{ padding: "10px", color: theme.palette.success.dark }}>{t('prepaymentId')} {prepayment.numero}</Typography>
        <Typography variant="subtitle1" sx={{ padding: "10px", color: theme.palette.success.dark }}>{t('prepaymentTotal')} {formattedCurrency(balanceTotalPrepayment())}</Typography>
        <Typography variant="subtitle1" sx={{ padding: "10px", color: theme.palette.success.dark }}>{t('cumulative')} {formattedCurrency(cumulative())}</Typography>
        <Typography variant="subtitle1" sx={{ padding: "10px", color: theme.palette.success.dark }}>{t('prepaymentBalance')} {formattedCurrency(balancePrepayment(false) - cumulative())}</Typography>
      </>
    );
  };

  const DetailList = () =>
    <Stack style={{ display: 'flex', flexDirection: 'row', justifyContent: "center", maxWidth: "1800px", width: "1500px" }}>
      <Stack style={{
        display: 'flex', flexDirection: 'column', marginBottom: "20px", alignContent: "center",
        borderRadius: "10px", minWidth: "770px", maxWidth: "1500px", width: "1400px"
      }}>
        <ISTableTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
          <Typography variant="h6" sx={{ padding: "10px", color: theme.palette.success.dark }}>{t('inProgress')}&nbsp;
            <IconButton onClick={() => setShowInfoPreorderDialog(true)}>
              <Tooltip title={t('info', { ns: 'delivery' })}>
                <InfoOutlined style={{ color: theme.palette.success.dark }} />
              </Tooltip>
            </IconButton>
          </Typography>
          <PrepaymentInfo prepayment={props.prepayment} />
        </ISTableTitle>
        <TableContainer sx={{ overflowX: 'auto', maxHeight: '180px', height: '180px' }}>
          {!props.loadingOthers &&
            <Table size="small" stickyHeader={true}>
              <TableHead >
                <TableRow selected={true}>
                  <ISTableHeaderCell>{t('brand')}</ISTableHeaderCell>
                  <ISTableHeaderCell>{`${t('product')}`} {props?.preorderState?.preorder?.detail?.length ? `( ${props.preorderState.preorder.detail?.length} )` : ''}</ISTableHeaderCell>
                  <ISTableHeaderCell align='center'>{t('code')}</ISTableHeaderCell>
                  <ISTableHeaderCell align='right'>{t('packageQty')}</ISTableHeaderCell>
                  <ISTableHeaderCell align='center'>{t('qty')}</ISTableHeaderCell>
                  <ISTableHeaderCell align='right'>{t('priceList')}</ISTableHeaderCell>
                  <ISTableHeaderCell align='right'>{t('price')}</ISTableHeaderCell>
                  <ISTableHeaderCell align='right'>{t('subtotal')}</ISTableHeaderCell>
                  <ISTableHeaderCell align='center' sx={{ cursor: 'pointer', padding: '0px' }}
                    tooltip={tooltipText(t('deleteAll'))}
                    onClick={(e) => { e.stopPropagation(); handleDeleteAll() }}>
                    <DeleteForeverOutlined />
                  </ISTableHeaderCell>
                  <GenericModalDialog
                    dialogProps={{ open: showDeleteAllDialog }}
                    isOpen={showDeleteAllDialog}
                    onConfirm={() => deleteAll()} onCancel={() => setShowDeleteAllDialog(false)} title={t('inProgress')}>
                    <Typography>{t("areYouSureDeleteAll")}</Typography>
                  </GenericModalDialog>

                </TableRow>
              </TableHead>
              <TableBody>
                {!props.loading && !deletingDetails &&
                  notShowingDialogs() &&
                  props.preorderState.preorder &&
                  preorderId &&
                  props.preorderState.preorder.detail &&
                  props.preorderState.preorder.detail.sort((a, b) => a && b ? (b.id! - a.id!) : 0).map((row, index) => {
                    return <ISTableRow key={index} color={mapActionToColor()} sx={{ lineHeight: "0.5rem", fontSize: "12px" }}>
                      <ISTableCell sx={{ lineHeight: "0.5rem", fontSize: "12px" }} >
                        {row.product?.brand?.description}
                      </ISTableCell>
                      <ISTableCell sx={{ lineHeight: "0.5rem", fontSize: "12px" }} >
                        {row.productName}
                      </ISTableCell>
                      <ISTableCell align='center' sx={{ lineHeight: "0.5rem", fontSize: "12px" }} >
                        {row.code}
                      </ISTableCell>
                      <ISTableCell align='right' sx={{ lineHeight: "0.5rem", fontSize: "12px" }}>
                        {row.package}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </ISTableCell>
                      <ISTableCell align='center' sx={{ cursor: 'pointer', padding: "0px" }}>
                        <PreorderDetailUpsert editing={true} detail={row}
                          setPreorder={setPreorder}
                          getPreorder={getPreorder}
                          disable={!row.price}
                          getBalancePrepayment={balancePrepayment} />
                      </ISTableCell>
                      <ISTableCell align='right' sx={{ lineHeight: "0.5rem", fontSize: "12px" }}>
                        {!row.listPrice ? '' : t(`money.${row.money}`)} {`${formattedNoMoneyCurrency(row.listPrice)}`}
                      </ISTableCell>
                      <ISTableCell align='right' sx={{ lineHeight: "0.5rem", fontSize: "12px" }}>
                        {!row.price ? '' : t(`money.${row.money}`)} {`${formattedNoMoneyCurrency(row.price)}`}
                      </ISTableCell>
                      <ISTableCell align='right' sx={{ lineHeight: "0.5rem", fontSize: "12px" }}>
                        {!row.amount ? '' : t(`money.${row.money}`)} {`${formattedNoMoneyCurrency(row.amount)}`}
                      </ISTableCell>
                      <ISTableCell tooltip={tooltipText(t('delete'))}
                        align='center' sx={{ cursor: 'pointer', lineHeight: "0.5rem", fontSize: "12px" }} onClick={(e) => { e.stopPropagation(); row.id && onClickDelete(row.id) }}>

                        <DeleteOutlineOutlined />
                      </ISTableCell>
                    </ISTableRow>
                  }
                  )}
                {!props.loadingOthers &&
                  props.preorderState.preorder &&
                  props.preorderState.preorder.detail &&
                  props.preorderState.preorder.detail.length === 0 &&
                  <ISTableRow key={"nothing"} color={mapActionToColor()} sx={{ lineHeight: "0.5rem", fontSize: "12px" }}>
                    <ISTableCell colSpan={9} align='center' sx={{ lineHeight: "0.5rem", fontSize: "12px" }}>
                      <Typography variant="h6" textAlign="center">{t('nothing')}</Typography>
                    </ISTableCell>
                  </ISTableRow>
                }
              </TableBody>
            </Table>}
          {
            (props.loadingOthers || deletingDetails || revaluing) &&
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress size={25} />
            </div>
          }
        </TableContainer>
      </Stack>
      <Stack style={{ display: 'flex', flexDirection: 'column', minHeight: "180px", marginLeft: "20px", marginBottom: "50px", alignItems: "center", justifyContent: "space-around" }}>
        <ProgressButton state={props.session}
          type="button"
          onClick={(e) => { e.stopPropagation(); handleRemarks() }}
          style={{ minWidth: "150px", textTransform: "none", borderRadius: '8px', display: "flex", justifyContent: "flex-start" }}>
          <ShoppingCartCheckoutOutlined />
          <Typography style={{ marginLeft: "5px", color: theme.palette.success.dark }}>{t('confirm')}</Typography>
        </ProgressButton>
        {showRemarksDialog && <RemarksDialog
          onCancel={() => setShowRemarksDialog(false)}
          obs={preorderInfo.remarks}
          purchaseOrder={preorderInfo.purchaseOrder!}
          onConfirm={(value1, value2) => { setPreorderInfo({ ...preorderInfo, remarks: value1, purchaseOrder: value2 }); remarks(); }}
        />}


        {showChangePricesDialog && !props.loadingOthers &&
          !props.loading &&
          !props.preorderProductList?.isFetching &&
          !props.preorderAllProductList?.isFetching &&
          !props.productList?.isFetching &&
          <GenericModalDialog
            dialogProps={{ open: showChangePricesDialog }}
            isOpen={showChangePricesDialog}
            onConfirm={() => revalueAll()} onCancel={() => discard()} title={t('inProgress')}
            textOk={t('revalue')}
            textCancel={t('discard')}>
            <Typography>{t("priceListChanges")}</Typography>
          </GenericModalDialog>}

        {showInfoPreorderDialog && !props.loadingOthers &&
          !props.loading &&
          !props.preorderProductList?.isFetching &&
          !props.preorderAllProductList?.isFetching &&
          !props.productList?.isFetching &&
          <GenericModalDialog isOpen={showInfoPreorderDialog}
            dialogProps={{ open: showInfoPreorderDialog, maxWidth: "lg" }}
            onConfirm={() => setShowInfoPreorderDialog(false)}
            title={t('info', { ns: 'delivery' })}>
            <Stack>
              <Typography variant="subtitle1">&nbsp;</Typography>
              <Typography variant="subtitle1">{t('address', { ns: 'delivery' })}:&nbsp;{preorderInfo.dl_address}</Typography>
              <Typography variant="subtitle1">{t('zipCode', { ns: 'delivery' })}:&nbsp;{preorderInfo.dl_zipCode}</Typography>
              <Typography variant="subtitle1">{t('locality', { ns: 'delivery' })}:&nbsp;{preorderInfo.dl_locality}</Typography>
              <Typography variant="subtitle1">{t('state', { ns: 'delivery' })}:&nbsp;{props.provinceList?.provinces?.find(province => province.codigo_provincia.toString() === preorderInfo.dl_provinceCode?.toString())?.descripcion}</Typography>
              <Typography variant="subtitle1">{t('phoneNumber', { ns: 'delivery' })}:&nbsp;{preorderInfo.dl_phone}</Typography>
              <Typography variant="subtitle1">{t('openingHours', { ns: 'delivery' })}:&nbsp;{preorderInfo.dl_openingHours}</Typography>
              {preorderInfo.internalRemarks && <Typography variant="subtitle1">{t('whoReceives', { ns: 'delivery' })}:&nbsp;{preorderInfo.internalRemarks}</Typography>}
              <Typography variant="subtitle1">&nbsp;</Typography>
              <Divider />
            </Stack>
          </GenericModalDialog>
        }
        <GenericModalDialog isOpen={showConfirmDialog}
          dialogProps={{ open: showConfirmDialog, maxWidth: "lg" }}
          onConfirm={() => confirmPreorder()} onCancel={() => setShowConfirmDialog(false)} title={t('inProgress')}>
          <Stack textAlign="center">
            <Typography variant="subtitle1">{t("areYouSureConfirm")}</Typography>
            {props.prepayment && balancePrepayment(false) - cumulative() < 0 &&
              <>
                <Typography>{<br />}</Typography>
                <Box flexDirection='row'>
                  <Typography sx={{ fontWeight: 'bold', display: 'inline-block' }} variant="body1">{t("noteConfirmSurplusTitle")}</Typography>
                  <Typography sx={{ fontWeight: 'bold', display: 'inline-block' }} color="red" variant="body1">&nbsp;{formattedCurrency(Math.abs(balancePrepayment(false) - cumulative()))}</Typography>
                </Box>
                <Typography sx={{ fontWeight: 'bold' }} variant="body1">{t("noteConfirmSurplus")}</Typography>
              </>}
            <Typography>{<br />}</Typography>
            <Typography variant="body2">{t("noteConfirm1")}</Typography>
            <Typography>{<br />}</Typography>
            <Typography variant="body2">{t("noteConfirm2")} </Typography>
            <Typography variant="body1">{t("orders", { ns: 'menu' })}</Typography>
          </Stack>
        </GenericModalDialog>
        <ProgressButton state={props.session}
          type="button"
          onClick={(e) => { e.stopPropagation(); handleDiscard() }}
          style={{ minWidth: "150px", textTransform: "none", borderRadius: '8px', display: "flex", justifyContent: "flex-start" }}>
          <RemoveShoppingCartOutlined />
          <Typography style={{ marginLeft: "5px", color: theme.palette.success.dark }}>{t('discard')}</Typography>
        </ProgressButton>
        <GenericModalDialog isOpen={showDiscardDialog} onConfirm={() => discard()} onCancel={() => setShowDiscardDialog(false)} title={t('inProgress')}>
          <Typography>{t("areYouSureDiscard")}</Typography>
        </GenericModalDialog>
        <ProgressButton state={props.session}
          type="button"
          onClick={(e) => { e.stopPropagation(); brandListCumulative() }}
          style={{ minWidth: "150px", textTransform: "none", borderRadius: '8px', display: "flex", justifyContent: "flex-start" }}>
          <FunctionsOutlined />
          <Typography style={{ marginLeft: "5px", color: theme.palette.success.dark }}>{t('brandList')}</Typography>
        </ProgressButton>
        <ProgressButton state={props.session}
          type="button"
          onClick={(e) => { e.stopPropagation(); handleXlsPreviuosImport() }}
          style={{ minWidth: "150px", textTransform: "none", borderRadius: '8px', display: "flex", justifyContent: "flex-start" }}>
          <UploadFileOutlined />
          <Typography style={{ marginLeft: "5px", color: theme.palette.success.dark }}>{t('upload')}</Typography>
        </ProgressButton>

        <XlsImportPreorderDialog isOpen={showXlsImportPreorderDialog}
          preorderId={preorderInfo.id || 0}
          products={props.productList!}
          balance={balancePrepayment(true) - cumulative()}
          preorderAllProductList={props.preorderAllProductList!}
          priceListId={props.priceList?.codigo_listadeprecios!}
          money={props.priceList?.moneda!}
          currentPreorderList={props.preorderState.preorder?.detail || []}
          onConfirm={(preorderBulkData) => { handleBulkPreorderImport(preorderBulkData) }}
          onCancel={() => setShowXlsImportPreorderDialog(false)}
        />

        <GenericModalDialog isOpen={showBrandCumulativeDialog}
          dialogProps={{ open: showBrandCumulativeDialog, maxWidth: "lg" }}
          onConfirm={() => setShowBrandCumulativeDialog(false)} title={t('brandListTitle')}>
          <Stack textAlign="center">
            <Box style={{ justifyContent: 'center' }}>
              <Table size="medium" stickyHeader={true}>
                <TableHead >
                  <TableRow selected={true}>
                    <ISTableHeaderCell>{t('brand')}</ISTableHeaderCell>
                    <ISTableHeaderCell></ISTableHeaderCell>
                    <ISTableHeaderCell align='right'>{t('subtotal')}</ISTableHeaderCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {brandListData && brandListData.map((row, index) => {
                    return <ISTableRow key={index} color={mapActionToColor()} sx={{ lineHeight: "0.5rem", fontSize: "12px" }}>
                      <ISTableCell >
                        {/*row.brand*/}
                        <img
                          loading="lazy"
                          width="100"
                          src={require(`/public/img/brands/${row.code}.png`)}
                          alt={`${row.code}.png`}
                        />
                      </ISTableCell>
                      <ISTableCell >
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </ISTableCell>
                      <ISTableCell align='right'>
                        {formattedNoMoneyCurrency(row.total!)}
                      </ISTableCell>
                    </ISTableRow>
                  })}
                </TableBody>
              </Table>
            </Box>
          </Stack>
        </GenericModalDialog>
      </Stack>
    </Stack >

  const FiltersPreorderProducts = () => {
    /*const [filters, setFilters] = useState({
      brand: '',
      section: '',
      group: '',
      subgroup: '',
    });*/

    const clearDependentFilters = (filters: Filters, name: string) => {
      return {
        ...filters,
        section: name !== 'section' ? '' : filters.section,  // Limpia el filtro de sección
        group: name !== 'group' ? '' : filters.group,    // Limpia el filtro de grupo
        subgroup: '', // Limpia el filtro de subgrupo
      };
    };

    return (
      <Stack style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap' }}>
        <FiltersBar
          defaultFilters={initPreordersFilters}
          noControlFilters
          resetOnChange={["brand", "section", 'group']}
          clearDependentFilters={clearDependentFilters}
        >
          <FilterBrand name='brand' label={t("brands")} style={{ maxWidth: "300px", width: "300px", marginRight: "10px" }}
            //value={filters.brand}
            menuItems={brandList()} />

          <FilterPreorderStuff name="section" label={t("sections")} style={{ maxWidth: "200px", width: "200px", marginRight: "10px" }}
            //value={filters.section}
            //onChange={(event: any) => handleFilterChange('section', event.target.value)}
            menuItems={sectionList()} />

          <FilterPreorderStuff name="group" label={t("groups")} style={{ maxWidth: "350px", width: "350px", marginRight: "10px" }}
            //value={filters.group}
            menuItems={groupList()} />

          <FilterPreorderStuff name="subgroup" label={t("products")} style={{ maxWidth: "350px", width: "350px", marginRight: "10px" }}
            //value={filters.subgroup}
            menuItems={subgroupList()} />
        </FiltersBar>
        <PreorderProductCodeForm />
      </Stack >
    );
  };

  const PreorderProductListInputs = () => {
    const { preorderProductList, priceList } = props; // Desestructuración de props
    const { isFetching, pagination } = preorderProductList || {};
    const rows = rowsToShow || [];

    const renderProductRow = (product: Product, index: number) => {
      const detail: PreorderDetailInput = {
        id: null,
        preorderId: preorderInfo.id || 0,
        productId: product.id || 0,
        code: product.code,
        qty: 0,
        package: product.package,
        priceListId: priceList?.codigo_listadeprecios,
        money: priceList?.moneda,
        listPrice: product.price,
        price: sumDiscounts(product.discounts!, product.price),
        discount1: Number(product.discounts?.bonificacion1),
        discount2: Number(product.discounts?.bonificacion2),
        discount3: Number(product.discounts?.bonificacion3),
        discount4: Number(product.discounts?.bonificacion4),
        discount5: Number(product.discounts?.bonificacion5),
        discount6: Number(product.discounts?.bonificacion6),
        discount7: Number(product.discounts?.bonificacion7),
        discount8: Number(product.discounts?.bonificacion8),
        discount9: Number(product.discounts?.bonificacion9),
        discount10: Number(product.discounts?.bonificacion10),
      };

      return (
        <ISTableCell key={product.code} tooltip={tooltipText(
          !product.discounts ? t('unableOnPrepayment') : product.measurementName
        )} padding="none" align="center">
          <PreorderDetailUpsert
            editing={false}
            detail={detail}
            disable={!product.discounts || !product.price}
            setPreorder={setPreorder}
            getPreorder={getPreorder}
            getBalancePrepayment={balancePrepayment}
          />
        </ISTableCell>
      );
    };

    return (
      <Stack style={{ display: 'flex', flexDirection: 'column', maxHeight: '100%', borderRadius: '10px', minWidth: '770px', width: '81vw' }}>
        <ISTableTitleSubtitle title={`${t('title')}`} subtitle={`${priceList ? `\u00A0\u00A0-\u00A0\u00A0\u00A0${t('listPrice')} ${priceList?.codigo_listadeprecios}` : ``}`} />

        <TableContainer sx={{ overflowX: 'auto', height: '100%' }}>
          {isFetching ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress size={25} />
            </div>
          ) : (
            <Table style={{ tableLayout: 'fixed' }} size="medium" stickyHeader>
              <TableBody>
                {notShowingDialogs() && rows.map((row, index) => (
                  <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{ cursor: 'pointer' }}>
                    <ISTableCell
                      style={{ width: '280px', background: theme.palette.info.main, position: 'sticky', left: 0, zIndex: 999 - index }}
                      component="th"
                      scope="row"
                      tooltip={tooltipText(`${row.data.description}${row.data.products.length > 0 && row.data.products[0].information ? `- ${row.data.products[0].information}` : ''}`)}
                    >
                      {row.data.code && <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <img
                          loading="lazy"
                          width="70"
                          src={require(`/public/img/products/${row.data.code.padStart(4, '0')}.png`)}
                          alt={`${row.data.code.padStart(4, '0')}.png`}
                        />
                        <Typography variant="body2" style={{ marginLeft: '5px', wordBreak: 'break-word', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                          {row.data.description}
                        </Typography>
                      </Box>}
                    </ISTableCell>

                    {row.data.products && row.data.products.length > 0 && (
                      <Table style={{ width: 'auto' }} size="small">
                        <TableHead>
                          <TableRow selected>
                            {row.data.products
                              .sort((a, b) => (a?.order || 0) - (b?.order || 0))
                              .map((product, idx) => (
                                <ISTableHeaderCell key={idx} tooltip={tooltipText(product.code)} padding="none" align="center" sx={{ minWidth: '180px', width: '180px', lineHeight: '0.5rem', fontSize: '12px' }}>
                                  {product.measurementName}
                                </ISTableHeaderCell>
                              ))}
                            <CompleteHeaderCells initial={row.data.products.length} />
                          </TableRow>
                          <TableRow selected>
                            {row.data.products
                              .sort((a, b) => (a?.order || 0) - (b?.order || 0))
                              .map((product, idx) => (
                                <ISTableHeaderCell key={idx} tooltip={tooltipText(!product.price ? t('notAvailable') : `${t('priceList')} ${t(`money.${product.money}`)} ${formattedNoMoneyCurrency(product.price)}`)} padding="none" align="center" sx={{ minWidth: '180px', width: '180px', lineHeight: '0.5rem', fontSize: '12px' }}>
                                  {!product.price ? '' : t(`money.${product.money}`)} {formattedNoMoneyCurrency(sumDiscounts(product.discounts!, product.price))}
                                </ISTableHeaderCell>
                              ))}
                            <CompleteHeaderCells initial={row.data.products.length} />
                          </TableRow>
                          <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{ cursor: 'pointer' }}>
                            {row.data.products
                              .sort((a, b) => (a?.order || 0) - (b?.order || 0))
                              .map(renderProductRow)}
                            <CompleteDataCells initial={row.data.products.length} />
                          </ISTableRow>
                        </TableHead>
                      </Table>
                    )}
                  </ISTableRow>
                ))}
              </TableBody>
            </Table>
          )}

          <PaginationButtons pagination={pagination} />
        </TableContainer>
      </Stack>
    );
  };

  const preorderProductListInputs = React.useMemo(() => <PreorderProductListInputs />,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rowsToShow, props.preorderProductList, darkModeChange]);

  return (
    <Stack style={{ display: 'flex', flexDirection: 'column', maxHeight: '60%', borderRadius: "10px", minWidth: '770px' }}>
      <DetailList />
      {!props.loadingOthers && !props.loading && <FiltersPreorderProducts />}
      {preorderProductListInputs}
    </Stack>
  );
}

const mapStateToProps = (state: AppState) => ({
  preorderProductList: state.preorderProductList,
  preorderAllProductList: state.preorderAllProductList,
  preorderDetail: state.preorderDetailList
})

export default connect(mapStateToProps, null)(PreorderProducts)